import React from "react"
import { useLocation, useNavigate } from "react-router"

import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined"
import { Button, Link, Stack, Typography } from "@mui/material"

export const ErrorBoundaryFallback = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const currentUrl = `${location.pathname}${location.search}`

  return (
    <Stack
      direction="column"
      role="alert"
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 88px)",
        width: "100%",
      }}
    >
      <ErrorOutlinedIcon
        aria-hidden="true"
        sx={{ fontSize: 120, color: "neutral.main" }}
      />
      <Typography
        align="center"
        variant="h1"
        sx={{
          color: "neutral.main",
          width: "80%",
        }}
      >
        Oops&hellip; Something went wrong
      </Typography>
      <Button
        component={Link}
        href={currentUrl}
        onClick={() => {
          void navigate(0)
        }}
        variant="contained"
      >
        Refresh Page
      </Button>
    </Stack>
  )
}
